<div routerLink="/scanner/scan">
  <image-loader-utils url="scanner-qr-re" extraClasses="icon-svg"></image-loader-utils>
</div>
<div *ngIf="this.couponDetailList && this.couponDetailList.length > 0; then thenBlock; else elseBlock"></div>
<ng-template #thenBlock class="cashout-main">
  <div class="headerDecs">
    <h2>{{ 'betting_slip_details' | t }}</h2>
  </div>
  <div class="cashout-slip-item">
    <div class="slip-top-area">
      <div class="slip-top-left-area">
        <div class="slip-combine">
          <p>{{ this.couponDetailList[0].SlipType }}</p>
          <div class="slip-live" *ngIf="this.isLive">
            <p>{{ 'LIVE' | t }}</p>
          </div>
        </div>
      </div>
      <div class="slip-top-right-area">
        <div>
          <div class="slip-top-pw">
            <p>
              Status: <span class="slip-top-right-m">{{ this.couponDetailList[0].SlipState }}</span>
            </p>
          </div>
          <div class="slip-top-skate">
            <p>
              STAKE: <span class="slip-top-right-m">{{ this.couponDetailList[0].Amount }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="slip-center-area">
      <ng-container *ngIf="slipDetailList && slipDetailList.length > 0">
        <div class="match-item-container" *ngFor="let matchItem of slipDetailList; trackBy: trackBySlipId" (click)="goEventDetail(matchItem.BetradarMatchId)">
          <div class="match-top">
            <div class="odd-name">
              <div *ngIf="matchItem.Banko === 1" class="match-top-banko"><p>B</p></div>
              <p class="odd-name-p">{{ matchItem.OddsType }} {{ matchItem.SpecialBetValue }} ({{ matchItem.Outcomes }})</p>
            </div>
            <div class="match-odd">
              <p>{{ matchItem.OddValue }}</p>
              <p *ngIf="matchItem.StateId === 3" class="math-won-status">{{ 'CASHOUT.WON' | t }}</p>
              <p *ngIf="matchItem.StateId === 4" class="math-lost-status">{{ 'CASHOUT.LOST' | t }}</p>
              <p *ngIf="matchItem.StateId === 2" class="math-lost-status">{{ 'CASHOUT.CANCELED' | t }}</p>
            </div>
          </div>
          <div class="match-bottom">
            <div class="match-description">
              <div class="match-description-column-one">
                <p>{{ matchItem.EventName }}</p>
              </div>
              <div *ngIf="matchItem.BetTypeId === 1" class="match-description-column-two">
                <p>Score {{ matchItem.HomeTeamScore }}:{{ matchItem.AwayTeamScore }}</p>
              </div>
            </div>
            <div *ngIf="matchItem.BetTypeId === 1" class="match-score-and-minute">
              <p>{{ matchItem.HomeTeamScore }}:{{ matchItem.AwayTeamScore }}</p>
              <p class="match-minute">{{ matchItem.MatchStatus }}</p>
            </div>
            <div *ngIf="!(matchItem.MatchStatus && matchItem.MatchStatus !== '')" class="match-score-and-minute pre">
              <p>{{ matchItem.EventDateIso | dateFormat : 'dd.MM.yy' }}</p>
              <p>{{ matchItem.EventDateIso | dateFormat : 'HH:mm' }}</p>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
<ng-template #thenBlock class="slipId-container">
  <p class="cashout-createdDate">Created Date: {{ this.couponDetailList[0].CreateDateISO | dateFormat : 'dd.MM.yy HH:mm' }}</p>
  <p class="cashout-slipID" (click)="goEventDetail(this.couponDetailList[0].SlipId)">#{{ this.couponDetailList[0].SlipId }}</p>
</ng-template>
<ng-template #elseBlock>
  <div class="headerDecs">
    <h2>{{ 'betting_slip_details' | t }}</h2>
  </div>
  <div class="scanner-error-message">
    <p>
      {{ 'SCANNER_TICKET.NOT_FOUND' | t }}
    </p>
  </div>
</ng-template>
